module.exports = __webpack_public_path__ + "img/8.493fa0ca.gif";